module.exports = __webpack_public_path__ + "static/translators-4cc96066c2fbe0650bdae3fff7d18e34.jpg";